import React from "react"
import ReactTooltip from "react-tooltip"

type OwnProps = {
    featureKey: string, 
    message: string,
}

const ToggleTooltipComponent = (props: OwnProps) => {
    return <ReactTooltip
        place="bottom"
        className="toggleLock px-3"
        id={"toggleTooltip-anchor" + props.featureKey}
        type="dark"
        effect="solid"
        multiline={true}
    >
        {props.message}
    </ReactTooltip>
}

export default ToggleTooltipComponent


// WEBPACK FOOTER //
// ./src/integration/form/ToggleTooltipComponent.tsx